import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { enGB } from "date-fns/locale";
import {
  Box,
  Button,
  CircularProgress,
  Grid,
  Modal,
  Stack,
  TextField,
  Typography
} from "@mui/material";
import moment from "moment";
import React, { useState } from "react";
import Select from "react-select";
import { assignPrimeProductToGuest } from "src/api/primestockapi";
import { notification } from "src/utils/messages";
import { canAssignStock, getLoggedInUser } from "src/utils/stockPermission";

// Privilege offers "Assign to City" and "Assign to Guest" from this modal.
// Prime has no city tier, so this is the guest form only - same fields, same
// order as the Privilege guest branch. Member assignment lives on the Products
// card and opens the member list.
export default function AssignProductModal({
  assignProductModal,
  setAssignProductModal,
  toggleAssignProductModal,
  rowData,
  handleGetProducts
}) {
  let user = getLoggedInUser();
  const canAssign = canAssignStock(user);

  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 700,
    bgcolor: "background.paper",
    boxShadow: 10,
    borderRadius: "10px",
    p: 2
  };

  const [loader, setLoader] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const [assignData, setAssignData] = useState({
    assign_to: 2,
    assign_name: "",
    p_qty: "",
    date: new Date()
  });

  const assignOptions = [{ value: 2, label: "Assign to Guest" }];

  const resetFormData = () => {
    setAssignData({ assign_to: 2, assign_name: "", p_qty: "", date: new Date() });
  };

  const handleAssignProduct = async () => {
    if (assignData.assign_name.trim() === "") {
      notification({ type: "error", message: "Please Fill All Fields data" })();
      return;
    }
    if (assignData.p_qty === "" || assignData.date === "") {
      notification({ type: "error", message: "Please Fill All Fields data" })();
      return;
    }

    setLoader(true);
    setIsLoading(true);

    const resp = await assignPrimeProductToGuest({
      assign_name: assignData.assign_name.trim(),
      p_id: rowData.p_id,
      p_type: rowData.p_type,
      p_qty: parseInt(assignData.p_qty) || 1,
      u_id: user?.u_id,
      u_name: user?.name,
      date: moment(assignData.date).format("DD-MM-YYYY")
    });

    setIsLoading(false);
    let notify = notification({
      type: resp.status == 0 ? "error" : "success",
      message: resp.message
    });
    notify();
    if (resp.status != 0) {
      resetFormData();
      toggleAssignProductModal();
      handleGetProducts();
    }
    setLoader(false);
  };

  return (
    <Modal
      open={assignProductModal}
      onClose={() => toggleAssignProductModal()}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style}>
        <Typography
          id="modal-modal-title"
          variant="h6"
          component="h2"
          style={{ marginBottom: "5px", textAlign: "center" }}
        >
          {rowData.p_name}
        </Typography>
        <hr />
        <Stack style={{ marginBottom: "15px" }}>
          <Grid container spacing={1}>
            <Grid item xs={6}>
              <Stack spacing={10} style={{ marginTop: "15px" }}>
                <Select
                  value={assignOptions.map((option) => {
                    if (option.value == assignData.assign_to) {
                      return { value: option.value, label: option.label };
                    }
                  })}
                  isDisabled
                  options={assignOptions}
                />
              </Stack>
            </Grid>
            <Grid item xs={6}>
              <Stack spacing={3} style={{ marginBottom: "15px", marginTop: "15px" }}>
                <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={enGB}>
                  <DatePicker
                    size="small"
                    sx={{ width: "100%" }}
                    label="Date"
                    value={assignData.date}
                    inputFormat="dd/MM/yyyy"
                    onChange={(newDate) => {
                      setAssignData({ ...assignData, date: newDate });
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        sx={{
                          "& .MuiInputBase-root": { height: 40 },
                          "& .MuiInputLabel-root": { top: "-6px" }
                        }}
                      />
                    )}
                  />
                </LocalizationProvider>
              </Stack>
            </Grid>

            <Grid item xs={6} style={{ marginBottom: "15px" }}>
              <TextField
                size="small"
                fullWidth
                required
                autoComplete="off"
                type="text"
                label="Guest Name"
                name="assign_name"
                placeholder="Enter Guest Name"
                onChange={(e) => {
                  setAssignData({ ...assignData, assign_name: e.target.value });
                }}
                value={assignData?.assign_name}
              />
            </Grid>

            <Grid item xs={6} style={{ marginBottom: "15px" }}>
              <TextField
                size="small"
                fullWidth
                required
                autoComplete="off"
                type="number"
                label="Quantity"
                name="p_qty"
                placeholder="Enter Quantity"
                onChange={(e) => {
                  setAssignData({ ...assignData, p_qty: e.target.value });
                }}
                value={assignData?.p_qty}
              />
            </Grid>

            <Grid
              item
              sm={12}
              xs={12}
              style={{
                display: "flex",
                justifyContent: "end",
                alignItems: "center"
              }}
            >
              <Button
                variant="outlined"
                onClick={() => toggleAssignProductModal()}
                style={{ marginTop: "15px", marginRight: "15px" }}
              >
                Close
              </Button>
              <Button
                variant="contained"
                style={{ marginTop: "15px" }}
                disabled={!canAssign}
                onClick={() => !loader && handleAssignProduct()}
                startIcon={isLoading && <CircularProgress size={20} color="inherit" />}
              >
                Submit
              </Button>
            </Grid>
          </Grid>
        </Stack>
      </Box>
    </Modal>
  );
}
